import { defineStore } from 'pinia'
import http from '@/lib/http'

export default defineStore('global', {
    state(){
        return {
            base_url: process.env.NODE_ENV == 'production' ? '' : 'http://192.168.101.105:8081',
            menuCurrentItem: '',
            token: localStorage.getItem('token') || '',
            config: {},
            r: 0,
            platform: localStorage.getItem('platform') || 'default',
            group: [],
            classList: [],
            work: [],
        }
    },
    actions: {
        async loadData() {
            let res = (await http.get('/api/v1/get-group-and-class-and-work')).data;
            this.group = res.group;
            this.classList = res.data.map((_)=>{
                _.self_add_examine = Boolean(_.self_add_examine)
                _.last_req_time = _.last_req_time ? new Date(_.last_req_time).format() : '无'
        
                return _
            });
        
            
            this.work = res.work;
        
        }
    }
})